/**
 * Library Requests paths used in document-request emails and the UI per portal.
 */
export const LIBRARY_REQUESTS_EMAIL_PATHS = {
  provider: "/Assessment/Requests",
  backend: "/Request/Library",
  sponsor: "/MyDocuments",
};

export const LIBRARY_REQUEST_DETAILS_ROUTE = "/Library/Requests/:id/Details";

export const buildLibraryRequestDetailsPath = (requestId) =>
  LIBRARY_REQUEST_DETAILS_ROUTE.replace(":id", encodeURIComponent(requestId));

export function getLibraryRequestsPathForRole(userRole) {
  if (userRole === "Sponsor User" || userRole === "Sponsor Master User") {
    return LIBRARY_REQUESTS_EMAIL_PATHS.sponsor;
  }

  if (
    userRole?.toLowerCase() === "provider user" ||
    userRole?.toLowerCase() === "provider master user"
  ) {
    return LIBRARY_REQUESTS_EMAIL_PATHS.provider;
  }

  if (userRole === "Backend User" || userRole === "Backend Master User") {
    return LIBRARY_REQUESTS_EMAIL_PATHS.backend;
  }

  return "/";
}
